export interface PricingCardData {
  id: string;
  name: string;
  icon: "monitor" | "dashboard" | "building";
  subtitle: string;
  pricing?: {
    monthly: {
      amount: string;
      currency: string;
      period: string;
      description: string;
      inr?: {
        amount: string;
        currency: string;
        period: string;
        description: string;
      };
    };
    annually: {
      amount: string;
      currency: string;
      period: string;
      description: string;
      inr?: {
        amount: string;
        currency: string;
        period: string;
        description: string;
      };
    };
  };
  customPricing?: {
    title: string;
    description: string;
  };
  discount?: {
    label: string;
    percentage: string;
  };
  ctaButton: {
    text: string;
    href: string;
    variant: "primary" | "outline";
  };
  topFeatures: string[];
  additionalFeatures?: {
    prefix: string;
    features: string[];
  };
}

export const pricingCards: PricingCardData[] = [
  {
    id: "professional",
    name: "Professional",
    icon: "monitor",
    subtitle: "All features you require to run a professional digital signage network",
    pricing: {
      monthly: {
        amount: "$15",
        currency: "USD",
        period: "/device/month",
        description: "billed monthly",
        inr: {
          amount: "₹900",
          currency: "INR",
          period: "/device/month",
          description: "billed monthly + GST",
        },
      },
      annually: {
        amount: "$13.5",
        currency: "USD",
        period: "/device/month",
        description: "billed annually",
        inr: {
          amount: "₹810",
          currency: "INR",
          period: "/device/month",
          description: "billed annually + GST",
        },
      },
    },
    discount: {
      label: "Save 10%",
      percentage: "10",
    },
    ctaButton: {
      text: "Start Free Trial",
      href: "https://console.pickcel.com/auth/register",
      variant: "primary",
    },
    topFeatures: [
      "Compatible with Android, Windows, BrightSign, Linux, Samsung, LG, iOS, Fire TV Stick, and Chrome OS",
      "Advanced content scheduling",
      "Display and media management",
      "100+ ready-made templates",
      "60+ content apps",
      "3 GB cloud storage",
      "1 User access",
    ],
  },
  {
    id: "business",
    name: "Business",
    icon: "dashboard",
    subtitle: "For growing organizations that need advanced analytics & control.",
    pricing: {
      monthly: {
        amount: "$25",
        currency: "USD",
        period: "/device/month",
        description: "billed monthly",
        inr: {
          amount: "₹1,500",
          currency: "INR",
          period: "/device/month",
          description: "billed monthly + GST",
        },
      },
      annually: {
        amount: "$22.5",
        currency: "USD",
        period: "/device/month",
        description: "billed annually",
        inr: {
          amount: "₹1,350",
          currency: "INR",
          period: "/device/month",
          description: "billed annually + GST",
        },
      },
    },
    discount: {
      label: "Save 8.3%",
      percentage: "8.3",
    },
    ctaButton: {
      text: "Start Free Trial",
      href: "https://console.pickcel.com/auth/register",
      variant: "primary",
    },
    topFeatures: [
      "All in our Professional plan +",
      "Live Zoom event streaming",
      "Multi Factor Authentication (MFA)",
      "Content synchronization",
      "Dashboards Integrations (Power BI, etc.)",
      "Supports 4K Media",
      "8 GB Storage",
      "Up to 5 users",
    ],
  },
  {
    id: "enterprise",
    name: "Enterprise",
    icon: "building",
    subtitle: "For large networks that need custom integrations, security, and support.",
    customPricing: {
      title: "Contact Sales",
      description: "Custom pricing for enterprise needs",
    },
    ctaButton: {
      text: "Contact Us",
      href: "/company/contact",
      variant: "outline",
    },
    topFeatures: [
      "Everything in Business, plus",
      "Dedicated / on-premise implementation",
      "Custom integration with external/enterprise applications",
      "Priority Enterprise support",
      "Custom screen attributes",
      "Unlimited Storage",
      "20+ user access",
    ],
  },
];

